import { render } from "./StarBackground.vue?vue&type=template&id=013db0cf&scoped=true"
import script from "./StarBackground.vue?vue&type=script&lang=js"
export * from "./StarBackground.vue?vue&type=script&lang=js"

import "./StarBackground.vue?vue&type=style&index=0&id=013db0cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.100.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013db0cf"]])

export default __exports__